import { Attribute, Directive } from '@angular/core';
import { AbstractControl, AsyncValidator, NG_ASYNC_VALIDATORS, ValidationErrors } from '@angular/forms';
import { VALIDATE_PATTERN_ERROR_PREFIX, validatePatternConfiguration } from '@df/ui/form/validate-pattern.config';
import { Observable } from 'rxjs/internal/Observable';
import { of } from 'rxjs/internal/observable/of';
import { debounceTime } from 'rxjs/internal/operators/debounceTime';
import { distinctUntilChanged } from 'rxjs/internal/operators/distinctUntilChanged';
import { map } from 'rxjs/internal/operators/map';
import { take } from 'rxjs/internal/operators/take';

@Directive({
    selector: '[validatePatternAsync]',
    standalone: true,
    providers: [
        {
            provide: NG_ASYNC_VALIDATORS,
            useExisting: ValidatePatternAsyncDirective,
            multi: true
        }
    ]
})
export class ValidatePatternAsyncDirective implements AsyncValidator {
    constructor(@Attribute('validatePatternAsync') public validatePatternAsync: string) {}

    /**
     * Returns pattern from config for used validate pattern id
     * @returns {RegExp | undefined}
     */
    get pattern(): RegExp | undefined {
        if (this.validatePatternAsync) {
            const patternConfig = validatePatternConfiguration[this.validatePatternAsync];

            if (patternConfig) {
                const pattern = patternConfig.pattern;

                if (pattern instanceof RegExp) {
                    return pattern;
                } else {
                    return new RegExp(pattern);
                }
            }
        }

        return undefined;
    }

    /**
     * Validation error to set on input
     * @returns {string}
     */
    get errorName(): string {
        return VALIDATE_PATTERN_ERROR_PREFIX + this.validatePatternAsync;
    }

    validate(control: AbstractControl): Observable<ValidationErrors | null> {
        if (!control.value?.length) {
            return of(null);
        }

        return of(control.value).pipe(
            debounceTime(500),
            distinctUntilChanged(),
            take(1),
            map(value => {
                const _value = value?.toString();
                return _value && this.pattern && !_value.match(this.pattern) ? { [this.errorName]: false } : null;
            })
        );
    }
}
